import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 640\" id=\"checkmark\">\n<path d=\"M576.001 74.667l-362.667 362.667-149.334-149.334-64 64 213.333 213.333 426.667-426.667z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol